export default {
  buttons: {
    login: 'Accedi',
  },
  feedback: {
    incorrect_code: 'Il codice inserito non è corretto. Riprova.',
    expired_code: 'Questo codice è scaduto. Richiedine uno nuovo.',
    too_many_attempts: 'Troppi tentativi. Attendi un momento e riprova.',
    unknown: 'Si è verificato un errore durante la verifica del codice. Riprova.',
    network_error: 'Impossibile raggiungere il server. Controlla la connessione e riprova.',
  },
};
